import React from 'react';
import { useAppState } from '../../BikesAppState.tsx';

import './ModalBackdrop.less';

const ModalBackdrop = () => {
  const { showFitAssistant, setShowFitAssistant } = useAppState();

  const onClose = () => {
    setShowFitAssistant(false);
  };

  return (
    <>
      <div
        className={`fit-assistant-modal-left-slide-in-backdrop ${showFitAssistant ? 'active' : ''}`}
        onClick={onClose}
      ></div>
    </>
  );
};

export default ModalBackdrop;
